import { NgModule } from '@angular/core';
import { SwitchComponent } from './switch/switch.component';
import { CommonModule } from '@angular/common';
import { DraggableModule } from './draggable.module';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';
import { ResizeSensorModule } from '@progress/kendo-angular-resize-sensor';
import { LocalizedMessagesDirective } from './switch/localization/localized-messages.directive';
import { SwitchCustomMessagesComponent } from './switch/localization/custom-messages.component';
var COMPONENT_DIRECTIVES = [
    SwitchComponent,
    SwitchCustomMessagesComponent,
    LocalizedMessagesDirective
];
var COMPONENT_EXPORTS = [
    SwitchComponent,
    SwitchCustomMessagesComponent,
    LocalizedMessagesDirective
];
/**
 * Represents the [NgModule](https://angular.io/docs/ts/latest/guide/ngmodule.html)
 * definition for the Switch component.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the Switch module
 * import { SwitchModule } from '@progress/kendo-angular-inputs';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, SwitchModule], // import Switch module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
var SwitchModule = (function () {
    function SwitchModule() {
    }
    return SwitchModule;
}());
export { SwitchModule };
SwitchModule.decorators = [
    { type: NgModule, args: [{
                declarations: COMPONENT_DIRECTIVES,
                exports: COMPONENT_EXPORTS,
                imports: [CommonModule, DraggableModule, ResizeSensorModule],
                providers: [
                    { provide: IntlService, useClass: CldrIntlService }
                ]
            },] },
];
/** @nocollapse */
SwitchModule.ctorParameters = function () { return []; };



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-inputs/dist/es/switch.module.js
// module id = ../../../../@progress/kendo-angular-inputs/dist/es/switch.module.js
// module chunks = 3